<!-- <template>
    <div class="PjanNavigationbar">
        <div class="tab_content" v-show="highcourt">
            <div class="tab_sent sent" @click="substance('/mediationlaw')">
                <p>中华人民共和国人民调解法</p>
                <span>点击查看 >></span>
            </div>
        </div>
        <router-view v-show="!highcourt"/>
    </div>
</template>
<script>
export default {
    data() {
        return {
            highcourt:true
        }
    },
    mounted() {
        setTimeout(() => {
            if(JSON.parse(sessionStorage.getItem("ssfwzn")) == '1') this.substance('/mediationlaw')
        },100)
    },
    methods:{
        substance(data){
            // this.highcourt = false
            if(data == this.$route.path) return
            this.$router.push(data)
        }
    },
    watch:{
        $route(to,from){
            if(to.path == '/JfznNavigationbar'){
                this.highcourt = true
            }else{
                this.highcourt = false
            }
        }
    }
}
</script>
<style lang="less" scoped>
.PjanNavigationbar{
    width: 100%;
    .tab_content{
        .tab_sent:hover p,.tab_sent:hover span{
            color:#BE1A0F;
        }
    }
}
</style> -->
<template>
    <div class="PjanNavigationbar">
        <div class="tab_content" v-show="this.$route.path == '/JfznNavigationbar'">
            <div class="tab_sent sent" @click="substance('/mediationlaw')">
                <p>中华人民共和国人民调解法</p>
                <span>点击查看 >></span>
            </div>
        </div>
        <router-view v-show="this.$route.path != '/JfznNavigationbar'"/>
    </div>
</template>
<script>
export default {
    data() {
        return {
            highcourt:true
        }
    },
    mounted() {
        setTimeout(() => {
            if(JSON.parse(sessionStorage.getItem("ssfwzn")) == '1') this.substance('/mediationlaw')
        },100)
    },
    methods:{
        substance(data){
            // this.highcourt = false
            if(data == this.$route.path) return
            this.$router.push(data)
        }
    },
    watch:{
        // $route(to,from){
        //     if(to.path == '/JfznNavigationbar'){
        //         this.highcourt = true
        //     }else{
        //         this.highcourt = false
        //     }
        // }
    }
}
</script>
<style lang="less" scoped>
.PjanNavigationbar{
    width: 100%;
    .tab_content{
        p{
            width: 250px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .tab_sent:hover p,.tab_sent:hover span{
            color:#BE1A0F;
        }
    }
}
</style>
